module.exports = __webpack_public_path__ + "6877179a1dbe9a76d4c43d2a56367087.woff2";